import React, { useMemo } from 'react'

import HeadData from 'components/Common/HeadData'

interface Props {
  offer: App.CruiseOffer
}

function CruiseHeadData(props: Props) {
  const { offer } = props

  const description = `${offer.name}. Book now with Luxury Escapes.`
  const image = offer.images[0]?.id
  const imageAlt = offer.name
  const title = `${offer.name} | Luxury`

  const purchasable = useMemo(() => {
    return offer?.departureDates && offer?.departureDates.length > 0
  }, [offer])

  return <HeadData
    title={title}
    description={description}
    imageId={image}
    imageAlt={imageAlt}
    noIndex={!purchasable}
  />
}

export default CruiseHeadData
